import React, { useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalProductosBodegasEditar = ({
                                         show,
                                         onHide,
                                         bodegas = [],
                                         data = {},
                                         setData,
                                         onSave
                                     }) => {

    // Inicializar stockBodegas al abrir el modal si no existe
    useEffect(() => {
        if (show && (!data.stockBodegas || data.stockBodegas.length === 0)) {
            setData({
                ...data,
                stockBodegas: bodegas.map(b => ({ bodegaId: b.id, stock: 0 }))
            });
        }
    }, [show, bodegas]);

    // Cuando cambia un stock, actualizamos en data.stockBodegas
    const handleStockChange = (bodegaId, value) => {
        const stockNum = Number(value) || 0;
        setData(prev => {
            const stockBodegas = prev.stockBodegas || [];
            const exists = stockBodegas.find(s => s.bodegaId === bodegaId);

            return {
                ...prev,
                stockBodegas: exists
                    ? stockBodegas.map(s =>
                        s.bodegaId === bodegaId ? { ...s, stock: stockNum } : s
                    )
                    : [...stockBodegas, { bodegaId, stock: stockNum }]
            };
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave();
    };

    const stockBodegas = data.stockBodegas || [];

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header
                closeButton
                style={{ background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)", color: "white" }}
            >
                <Modal.Title>📦 Ingresar Stock por Bodega</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {bodegas.length === 0 && <p>No hay bodegas cargadas.</p>}

                    {bodegas.map((bodega) => (
                        <Form.Group key={bodega.id} className="mb-3">
                            <Form.Label>
                                <strong>{bodega.nombre}</strong> – {bodega.puntoVenta ? 'Punto de Venta 🏪✔️' : 'Bodega 📦➡️'}
                            </Form.Label>

                            <Form.Control
                                type="text"
                                min="0"
                                placeholder="Ingrese stock"
                                value={stockBodegas.find(x => x.bodegaId === bodega.id)?.stock ?? 0}
                                onChange={(e) => handleStockChange(bodega.id, e.target.value)}
                                style={{ borderRadius: "8px" }}
                            />
                        </Form.Group>
                    ))}
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                        type="submit"
                        style={{
                            background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)",
                            border: "none"
                        }}
                    >
                        💾 Guardar
                    </Button>
                    <Button
                        style={{
                            background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)",
                            border: "none"
                        }}
                        onClick={onHide}
                    >
                        ✖️ Cerrar
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ModalProductosBodegasEditar;